import { z } from "zod";

export const unitOfMeasureSchema = z.enum(["Metric", "Imperial"]);

export type UnitOfMeasure = z.infer<typeof unitOfMeasureSchema>;
